import React from "react";
import { informations } from "../data/SiteData";
function TopBar(props) {
  return (
    <section id="topbar" class="d-flex align-items-center">
      <div class="container d-flex justify-content-center justify-content-md-between">
        <div class="contact-info d-flex align-items-center">
          <i class="bi bi-envelope-fill"></i>
          <a href="mailto:qanoonisuhaib@aol.com">{informations.email}</a>
          <i class="bi bi-phone-fill phone-icon"></i>
          <a href="callto:+93786702440">{informations.phone1}</a>
        </div>
        <div class="social-links d-none d-md-block">
          <a href={informations.twitter} class="twitter">
            <i class="bi bi-twitter"></i>
          </a>
          <a href={informations.facebook} class="facebook">
            <i class="bi bi-facebook"></i>
          </a>
          <a href={informations.instagram} class="instagram">
            <i class="bi bi-instagram"></i>
          </a>
          <a href={informations.linkedin} class="linkedin">
            <i class="bi bi-linkedin"></i>
          </a>
        </div>
      </div>
    </section>
  );
}

export default TopBar;
